(function initializeCustomifyRuntime(root) {
  'use strict';

  var DEFAULT_API_BASE_URL = 'https://lumlyusa.vercel.app';
  var configuredBase = root.CustomifyConfig && root.CustomifyConfig.apiBaseUrl;
  var apiBaseUrl = String(configuredBase || DEFAULT_API_BASE_URL).replace(/\/+$/, '');

  function apiUrl(resourcePath) {
    var normalizedPath = String(resourcePath || '');
    if (!normalizedPath.startsWith('/')) normalizedPath = '/' + normalizedPath;
    return apiBaseUrl + normalizedPath;
  }

  root.CustomifyApi = Object.freeze({
    baseUrl: apiBaseUrl,
    url: apiUrl
  });
})(typeof window !== 'undefined' ? window : globalThis);
